import { fetchData, setHeaderOptions } from "#/api/apiHelpers";

const ROUTE = "/admin/articles/media-ai-policy";

export type ArticleMediaPolicy = {
  policyKey: string;
  generationInstructions: string;
  layoutInstructions: string;
  reviewInstructions: string;
};

export type ArticleMediaPolicyResponse = {
  slug: string;
  policy: ArticleMediaPolicy;
  template?: { id: string } | null;
  activeVersion?: { id: string; version: string; created_at: string } | null;
};

export async function getArticleMediaPolicy(
  options?: { signal?: AbortSignal }
): Promise<ArticleMediaPolicyResponse> {
  const request = setHeaderOptions({ method: "GET" });
  return fetchData<ArticleMediaPolicyResponse>(ROUTE, {
    ...request,
    signal: options?.signal,
  });
}

export async function updateArticleMediaPolicy(payload: {
  policy: ArticleMediaPolicy;
  publish?: boolean;
}): Promise<ArticleMediaPolicyResponse> {
  const request = setHeaderOptions({
    method: "PUT",
    body: payload,
  });
  return fetchData<ArticleMediaPolicyResponse>(ROUTE, request);
}
